import Auth from '../auth/Auth';
import DefaultReportAirport from '../models/DefaultReportAirport';
import { WebClient } from './WebClient'

class ApiDefaultReportAirport extends WebClient {
    async getDefaultReportAirports(): Promise<DefaultReportAirport[]> {
        const url = "/airport/defaultreport";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async updateDefaultReportAirport(data: DefaultReportAirport): Promise<DefaultReportAirport> {
        return this.post("/airport/defaultreport", data, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }

    async deleteDefaultReportAirport(airportCode: string, reportAirportCode: string): Promise<boolean> {
        return this.delete(`/airport/defaultreport/${airportCode}/${reportAirportCode}`, Auth.getAuthToken()).then(res => {
            return res.status === 200;
        }).catch(() => { return false; });
    }
}

export default new ApiDefaultReportAirport();
